export default __webpack_public_path__ + "static/media/Essex_Icons_Closing.e7945ce2.svg";